<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="contents-wrapper">
    <div class="contents-container">
      <div class="img-wrapper">
        <app-zaver-icon [size]="88" name="diamond"></app-zaver-icon>
      </div>

      <div
        class="success-message"
        *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
      >
        Takk for at du betaler med Zaver.
      </div>
      <div
        class="success-message"
        *ngIf="state.paymentInformation.paymentMethod == 'CREDIT'"
      >
        Takk for at du betaler med Zaver.
      </div>
      <div
        class="success-message-vipps"
        *ngIf="state.paymentInformation.paymentMethod == 'VIPPS_EXTERNAL'"
      >
        Takk for betalingen!
      </div>

      <div
        class="info-message"
        *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
      >
        Fakturaen din vil bli sendt til den angitte e-postadressen innen 1-2
        dager.
      </div>
      <div
        class="info-message"
        *ngIf="state.paymentInformation.paymentMethod == 'CREDIT'"
      >
        Dine fakturaer vil bli sendt til den angitte e-postadressen din før det
        er på tide å betale.
      </div>

      <div class="details-list-wrapper smallest-mobile-hide">
        <hr class="details-divider" *ngIf="state" />
        <div class="details-container" *ngIf="state">
          <div class="details-key-entry">Totalbeløp</div>

          <div class="details-value-entry" *ngIf="state">
            {{ state.totalCheckoutValue | value }}
          </div>
        </div>

        <hr class="details-divider" *ngIf="paymentMethod" />
        <div class="details-container" *ngIf="paymentMethod">
          <div class="details-key-entry">Betalingsmetode</div>

          <div class="details-value-entry">
            {{ paymentMethod }}
          </div>
        </div>

        <hr class="details-divider" *ngIf="paymentMethod || state" />
      </div>

      <p *ngIf="noResponseMessage" class="no-response-message">
        {{ noResponseMessage }}
      </p>

      <zaver-button-link
        *ngIf="successUrl"
        class="merchant-return-link"
        (click)="onRouteToSuccessUrl()"
        [text]="'Gå tilbake til ' + state.checkoutCustomizations.merchantName"
      ></zaver-button-link>

      <div class="buttons-container">
        <div class="app-button" (click)="openTab(APP_STORE_LINK)">
          <app-zaver-icon class="apple-logo" override="dark" [size]="16" name="appleLogo" ></app-zaver-icon>
          App Store
        </div>

        <div class="app-button" (click)="openTab(PLAY_STORE_LINK)">
          <app-zaver-icon class="google-store" override="dark" [size]="16" name="googleStore"></app-zaver-icon>
          Google Play
        </div>
      </div>
    </div>
  </div>
</div>
